<template>
  <SogFlexColumn
    id="aside1"
    style="align-items: flex-start"
  >
    <InsuranceCardComponent
      :insurance="_insurance"
      :skeleton-visible="_loadDetails"
    >
      <SogCardActions
        :is-toolbar="true"
      >
        <SogCardActionButton
          mdi-icon="mdi-information"
          tooltip="Details anzeigen"
          @click="onDetails"
        />
        <SogCardActionButton
          v-show="isRoot && _insurance.vehicleRegistrationId"
          mdi-icon="mdi-car"
          tooltip="Zulassungsdaten"
          @click="onVehicleRegistration"
        />
      </SogCardActions>
    </InsuranceCardComponent>
    <SogCard v-show="_loadHistory || _history.length>0">
      <SogCardTitle>Historie</SogCardTitle>
      <SogCardContent>
        <HistoryListComponent :data="_history" />
      </SogCardContent>
      <SogCardContent>
        <SogSkeleton v-show="_loadHistory" />
      </SogCardContent>
    </SogCard>
    <SogCard v-show=" _loadFiles || _tempFile.length!==0">
      <SogCardTitle>Anhänge</SogCardTitle>
      <SogCardContent
        v-for="file in _tempFile"
        :key="file.id"
      >
        <FileCardComponent :file="file">
          <SogCardActionButton
            mdi-icon="mdi-download"
            tooltip="Download"
            @click="onDownload(file)"
          />
        </FileCardComponent>
      </SogCardContent>
      <SogCardContent>
        <SogSkeleton v-show="_loadFiles" />
      </SogCardContent>
    </SogCard>
  </SogFlexColumn>
</template>

<script setup lang="ts">

import InsuranceCardComponent from "@/modules/Insurance/components/InsuranceCardComponent.vue";
import FileCardComponent from "@/modules/FileUtils/components/FileCardComponent.vue";
import Insurance from "@/shared/model/Insurance";
import {reactive, ref, watch} from "vue";
import {useNavigationStore} from "@/modules/Navigation/store";
import {storeToRefs} from "pinia";
import SogSkeleton from "@/shared/ui/SogSkeleton.vue";
import apiInsurance from "@/modules/Insurance/api";
import SogCardActionButton from "@/shared/ui/SogCardActionButton.vue";
import SogCardActions from "@/shared/ui/SogCardActions.vue";
import SogFlexColumn from "@/shared/ui/SogFlexColumn.vue";
import SogCardContent from "@/shared/ui/SogCardContent.vue";
import SogCardTitle from "@/shared/ui/SogCardTitle.vue";
import SogCard from "@/shared/ui/SogCard.vue";
import ListFile from "@/shared/model/ListFile";
import apiFileUtils from "@/modules/FileUtils/api";
import apiHistory from "@/modules/History/api";
import History from "@/shared/model/History";
import getGuid from "@/shared/utils/getGuid";
import HistoryListComponent from "@/modules/History/components/HistoryListComponent.vue";
import {useAccountStore} from "@/stores/accountStore";
import {IdType} from "@/shared/model/idType";
import apiFile from "@/shared/services/apiFile";
import {useSpinner} from "@/shared/composables/SogSpinner";


const _navigationStore = useNavigationStore();
const {currentInsuranceId} = storeToRefs(_navigationStore);
const {isRoot} = storeToRefs(useAccountStore())
const _insuranceId = ref("")
const _loadDetails = ref(true)
const _insurance = ref<Insurance>(new Insurance())
const _tempFile = ref<ListFile[]>([])
const _loadFiles = ref(true)
const _loadHistory = ref(true)
const _history: History[] = reactive<History[]>([])
const _key = ref("")
const _spinner = useSpinner("aside1")



watch(currentInsuranceId, async () => {
  if (!currentInsuranceId.value) {
    return
  }
  if (currentInsuranceId.value === _insuranceId.value) {
    return;
  }

  _insuranceId.value = currentInsuranceId.value
   await load()
})

async function load() {
  if (!currentInsuranceId.value) {
    return
  }
  _insuranceId.value = currentInsuranceId.value ?? '';

  _key.value = getGuid();

  const t_loadDetails = loadDetails(_key.value);
  const t_loadHistory = loadHistory(_key.value);
  const t_loadFiles = loadFiles(_key.value);

  await Promise.allSettled([t_loadDetails, t_loadHistory, t_loadFiles]);

}

async function loadDetails(key: string) {
  if (!_insuranceId.value) {
    return
  }
  _loadDetails.value = true;
  const res = await apiInsurance.load(_insuranceId.value);
  if (_key.value !== key) {
    return;
  }
  if (res) {
    _insurance.value = res.insurance;
    _loadDetails.value = false;
  }
}

async function loadFiles(key: string) {
  if (!_insuranceId.value) {
    return;
  }
  try {
    _loadFiles.value = true
    const listFile = await apiFileUtils.listFileStore(_insuranceId.value)
    if (_key.value !== key) {
      return
    }
    if (listFile) {
      _tempFile.value = listFile?.sort((a, b) => (a.date && b.date) ? Date.parse(b.date.toString()) - Date.parse(a.date.toString()) : 0) ?? [];
    }
  } finally {
    _loadFiles.value = false
  }
}

async function loadHistory(key: string) {
  if (!_insuranceId.value) {
    return;
  }
  try {
    _loadHistory.value = true
    _history.length = 0
    const listHistory = await apiHistory.listInsurance(_insuranceId.value)
    if (_key.value !== key) {
      return
    }
    if (listHistory)
      _history.push(...listHistory)
  } finally {
    _loadHistory.value = false
  }
}

function onVehicleRegistration() {
  _navigationStore.currentVehicleRegistrationId = _insurance.value.vehicleRegistrationId
}

function onDetails() {
  _navigationStore.showObject(IdType.Insurance, currentInsuranceId.value)
  /*
    _navigationStore.currentInsuranceId = currentInsuranceId.value
    _router.push("/insurance/details")
  */
}

async function onDownload(file: ListFile) {
  if (!file.personId)
    return;
  try {
    _spinner.show()
    const fileId = await apiFileUtils.initDownloadFile(file.id ?? "");
    if (fileId)
      await apiFile.downloadTempFile(fileId)

  } finally {
    _spinner.hide()
  }
}

</script>

<style scoped>

</style>
